export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          Men's Asia Hockey Cup 2025
        </h3>

        <p className="card-text">
          Bihar is set to host the Hero Asia Cup 2025 for the very first time.
          The tournament will be played from 29th August to 7th September at the
          newly built Rajgir International Hockey Stadium, a world-class venue
          that stands as a symbol of the state’s growing sporting
          infrastructure.
        </p>

        <p className="card-text">
          This will be the 12th edition of the prestigious men’s hockey
          championship, bringing together top teams from India, China, Japan,
          Chinese Taipei, Malaysia, Korea and Oman. For hockey fans, it promises
          a thrilling spectacle of skill, speed, and fierce competition.
        </p>

        <p className="card-text">
          The Asia Cup carries a rich legacy. Korea has been the most dominant
          team with five titles, while India and Pakistan have each lifted the
          trophy three times. This edition is even more significant, as the
          winner will earn a direct qualification spot for the Hockey World Cup,
          raising the tournament’s global importance.
        </p>
        <p className="card-text">
          For Bihar, hosting the Asia Cup is not just a matter of pride, but
          also an opportunity to showcase its organizational strength and
          emerging sporting identity on the world stage.
        </p>
        <p className="card-text">
          Adding to the grandeur of the event, a Trophy Tour will commence on
          17th August. The journey will cover all districts of Bihar and extend
          to other key sporting hubs across the country, including Chennai,
          Chandigarh, Delhi, Odisha, Assam, and Jharkhand. The tour aims to
          ignite passion for hockey among the youth, spread the spirit of the
          game, and take the message of this historic tournament to every
          corner.
        </p>
        <p className="card-text">
          The successful hosting of the Hero Asia Cup at Rajgir will be a
          landmark moment for Bihar. Beyond sports, the tournament will also
          help promote tourism, culture, and heritage, strengthening Bihar’s
          image at the global level. It is set to be a unifying celebration,
          bringing together players, fans, and citizens to make this hockey
          festival truly unforgettable.
        </p>
        <br />
      </div>
    </div>
  );
}
